import CardChart from "../../components/Cards/CardChart";
import TableSocialTraffic from "../../components/Table/TableSocialTraffic";
import UserTable from "../../components/Table/User/UserTable";
import { useFetch } from "../../hooks/useFetch";
import Table from "../../layouts/Table";
import { useMemo } from "react";
import { ILog } from "../../types/logType";
import { IUser } from "../../types/userType";
import { OutletType } from "admin/src/types";

const UserStatus = ({context}: OutletType<IUser>) => {
	const [visit] = useFetch(
		useMemo<Partial<ILog>>(() => {
			return { target: context._id, action: "page" };
		}, [context]),
		"count"
	);

	const [interaction] = useFetch(
		useMemo<Partial<ILog>>(() => {
			return { target: context._id };
		}, [context]),
		"group"
	);

	return (
		<div className="relative grid gap-y-10">
			<div className="grid grid-cols-10 gap-x-10">
				<CardChart
					className="col-span-7"
					theme="dark"
					title="Visit and Chats"
					subtitle="insight"
					hover={false}
					data={visit}
				/>
				<CardChart
					className="col-span-3"
					theme="light"
					title="Interaction"
					type="doughnut"
					hover={false}
					data={interaction}
				/>
			</div>
			<div className="shadow-lg">
				<Table title="Shares">
					<TableSocialTraffic></TableSocialTraffic>
				</Table>
				<Table title="Compared">
					<TableSocialTraffic></TableSocialTraffic>
				</Table>
				<Table title="Reviews">
					<UserTable></UserTable>
				</Table>
			</div>
		</div>
	);
};

export default UserStatus;
